import { useCallback, useEffect } from 'react';
import { useSetRecoilState } from 'recoil';
import globalDataStatusAtom from '~/recoil/atom/globalDataStatus';
import platformAtom from '~/recoil/atom/platform';

import { platformListener } from '~/firebase/listeners/platform';

import { PLATFORM_ID } from '~/globalVariables';

// types
import { SnapshotFn } from '~/firebase/listeners/type';
import { Platform } from '~/types/platform/platform';
import { FirebaseDataStatus } from '~/types/utilities';

export default function usePlatform() {
  const setGlobalDataStatus = useSetRecoilState(globalDataStatusAtom);
  const setPlatform = useSetRecoilState(platformAtom);

  const handleSnapshot = useCallback<SnapshotFn>(
    (snap) => {
      const data = snap.data() as Platform | undefined;
      if (!snap.exists() || !data) {
        setGlobalDataStatus((prev) => ({ ...prev, platform: FirebaseDataStatus.NOT_EXIST }));
        return;
      }

      setGlobalDataStatus((prev) => ({ ...prev, platform: FirebaseDataStatus.EXIST }));

      setPlatform({
        id: snap.id,
        bannerCarouselSeconds: data.bannerCarouselSeconds,
        returnContainerPoints: data.returnContainerPoints,
        remotePickMealPoints: data.remotePickMealPoints,
        placeOrderCostLimit: data.placeOrderCostLimit,
        platformSetting: data.platformSetting,
        preOrderSetting: data.preOrderSetting,
        displayStores: data.displayStores,
        operatingTime: data.operatingTime,
        paymentTypes: data.paymentTypes,
        phoneNumber: data.phoneNumber,
        description: data.description,
        containers: data.containers,
        socialLink: data.socialLink,
        pinnedItems: data.pinnedItems,
        location: data.location,
        currency: data.currency,
        banners: data.banners,
        stores: data.stores,
        name: data.name,
        logo: data.logo,
        tags: data.tags,
        contactInfo: data.contactInfo,
      });
    },
    [setGlobalDataStatus, setPlatform],
  );

  useEffect(() => {
    const unlisten = platformListener(PLATFORM_ID, handleSnapshot);
    return () => {
      unlisten();
    };
  }, []);
}
